import { render, staticRenderFns } from "./NotPermission.vue?vue&type=template&id=7a401cac&lang=pug&functional=true&"
import script from "./NotPermission.vue?vue&type=script&lang=js&"
export * from "./NotPermission.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports